import React from "react";

import {apollo_useStyles } from "../atom/Apollo_styles";
import {ApolloFileSelect} from "../atom/Apollo_FileSelect";

import Button from "@material-ui/core/Button";
import Card from "@material-ui/core/Card/Card";
import CardContent from "@material-ui/core/CardContent";
import CardActions from "@material-ui/core/CardActions/CardActions";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";

export const ApolloFileUpload: React.FC<{
  accept?: string,
  handleDownloadTemplete: any,
  handleSave: any,
  immunityMessage?: string[],
  isMultiple?: boolean,
  isUploadDisable?: boolean,
  processing?: any,
  setBinary?: any,
  setFiles: any,
  title: string,
}> = ({
  accept,
  handleDownloadTemplete,
  handleSave,
  immunityMessage,
  isMultiple,
  isUploadDisable,
  processing,
  setBinary,
  setFiles,
  title,
}) => {
  const classes = apollo_useStyles();

  return (
    <React.Fragment>
      <Card className={classes.root} square variant="outlined">
        <CardContent>
          <Grid container>
            <Grid item xs={6}>
              <Typography variant="subtitle1" gutterBottom component="div">
                {title}
              </Typography>
            </Grid>
            <Grid item xs={6}>
              <Typography variant="button" gutterBottom component="div" align="right">
                <Button
                  variant="contained"
                  color="primary"
                  onClick={handleDownloadTemplete}
                  className={classes.button}
                >
                  テンプレートDL
                </Button>
              </Typography>
            </Grid>
          </Grid>
          <ApolloFileSelect
            setBinary={setBinary}
            setFiles={setFiles}
            accept={accept}
            isMultiple={isMultiple}
          />
        </CardContent>
        {
          immunityMessage
            ? immunityMessage.map((msg: string) =>
              <p style={{margin: "0", marginLeft: "20px", padding: "3px", color: "#595757"}}>{msg}</p>
            )
            : undefined
        }
        <CardActions className={classes.cardaction}>
          <Button
            variant="contained"
            color="primary"
            onClick={handleSave}
            className={classes.button}
            disabled={(processing?.current ?? false) || (isUploadDisable ?? false)}
          >
            アップロード
          </Button>
        </CardActions>
      </Card>
    </React.Fragment>
  );
}

export default ApolloFileUpload;
